const crmAssistantKnowledge = [
  {
    id: "dashboard",
    title: "Dashboard",
    module: "Dashboard",
    path: "/dashboard",
    menuPath: ["Dashboard"],
    description: "View CRM overview, operational metrics, and quick status snapshots.",
    keywords: ["dashboard", "home", "overview", "summary"],
    actions: ["Review business status", "Check recent activity"]
  },
  {
    id: "add-prospect",
    title: "Add Prospect",
    module: "Prospects",
    path: "/prospect/retail-prospect",
    menuPath: ["Prospects", "Add Prospect"],
    description: "Create a new retail prospect before converting it into a policy.",
    keywords: ["prospect", "lead", "add prospect", "create prospect"],
    actions: ["Capture prospect details", "Upload prospect policy documents"]
  },
  {
    id: "retail-prospect-manage",
    title: "Manage Retail Prospects",
    module: "Prospects",
    path: "/prospect/retail-prospect-manage",
    menuPath: ["Prospects", "Manage Prospects", "Retail"],
    privilege: "manageProspects.retail.active.view",
    alternatePrivileges: ["manageProspects.retail.lost.view"],
    description: "Track, edit, convert, or mark retail prospects as lost.",
    keywords: ["manage retail prospect", "convert prospect", "lost prospect", "pending prospect"],
    actions: ["Edit prospect", "Convert prospect", "Mark prospect lost"]
  },
  {
    id: "corporate-prospect-manage",
    title: "Manage Corporate Prospects",
    module: "Prospects",
    path: "/prospect/corporate-prospect-manage",
    menuPath: ["Prospects", "Manage Prospects", "Corporate"],
    privilege: "manageProspects.corporate.active.view",
    alternatePrivileges: ["manageProspects.corporate.lost.view"],
    description: "Track, edit, convert, or mark corporate prospects as lost.",
    keywords: ["corporate prospect", "manage corporate prospect", "convert corporate prospect"],
    actions: ["Edit corporate prospect", "Convert corporate prospect"]
  },
  {
    id: "add-policy",
    title: "Add Policy",
    module: "Transactions",
    path: "/add-policy",
    menuPath: ["Transactions", "Policy", "Add Policy"],
    description: "Create policy records, enter policy details, premiums, coverage, and upload policy documents.",
    keywords: ["add policy", "create policy", "policy document", "upload policy", "coverage type", "policy type", "class of policy"],
    actions: ["Create a policy", "Upload policy document", "Save draft policy"]
  },
  {
    id: "draft-policies",
    title: "Draft Policies",
    module: "Transactions",
    path: "/draft-policies",
    menuPath: ["Transactions", "Policy", "Draft Policies"],
    description: "Resume incomplete policies and continue pending policy entry work.",
    keywords: ["draft policy", "pending policy", "incomplete policy", "saved policy"],
    actions: ["Continue policy entry", "Review saved drafts"]
  },
  {
    id: "retail-converted-policy",
    title: "Retail Converted Policy",
    module: "Transactions",
    path: "/retail/converted-policy",
    menuPath: ["Transactions", "Converted Policy", "Retail"],
    privilege: "transactions.convertedPolicies.retail.view",
    alternatePrivileges: [],
    description: "Manage retail policies converted from prospects.",
    keywords: ["retail converted policy", "converted retail", "retail policy list"],
    actions: ["Edit converted retail policy", "Download policy details"]
  },
  {
    id: "corporate-converted-policy",
    title: "Corporate Converted Policy",
    module: "Transactions",
    path: "/corporate/converted-policy",
    menuPath: ["Transactions", "Converted Policy", "Corporate"],
    privilege: "transactions.convertedPolicies.corporate.view",
    alternatePrivileges: [],
    description: "Manage corporate policies converted from prospects.",
    keywords: ["corporate converted policy", "converted corporate", "corporate policy list"],
    actions: ["Edit converted corporate policy", "Download policy details"]
  },
  {
    id: "endorsement",
    title: "Endorsement",
    module: "Manage Policy",
    path: "/endorsements/add",
    menuPath: ["Manage Policy", "Endorsement"],
    privilege: "managePolicy.endorsements.management.view",
    description: "Create and manage endorsements used to modify or update existing policy details.",
    keywords: ["endorsement", "add endorsement", "policy modification", "modify policy", "endorsement document"],
    actions: ["Create endorsement", "Edit endorsement", "Download endorsement documents"]
  },
  {
    id: "claims",
    title: "Claims",
    module: "Manage Policy",
    path: "/claims",
    menuPath: ["Manage Policy", "Claims"],
    privilege: "managePolicy.claims.management.export",
    description: "Register and manage claim records with supporting claim documents.",
    keywords: ["claim", "claims", "manage claims", "upload claim", "claim document"],
    actions: ["Create claim", "Upload claim document", "Track claim status"]
  },
  {
    id: "renewals",
    title: "Renewals",
    module: "Manage Policy",
    path: "/renewals",
    menuPath: ["Manage Policy", "Renewals"],
    privilege: "managePolicy.renewals.processing.process",
    description: "Review policies due for renewal and process renewal activity.",
    keywords: ["renewal", "renew policy", "process renewal", "pending renewal", "expiring policy"],
    actions: ["Review renewals", "Process policy renewal"]
  },
  {
    id: "premium-register",
    title: "Premium Register",
    module: "Reports",
    path: "/retail/reports/premium-register",
    menuPath: ["Reports", "Premium Register"],
    privilege: "reports.premiumRegister",
    description: "Generate premium register reports for policy and premium tracking.",
    keywords: ["premium register", "premium report", "premium export"],
    actions: ["Generate Excel report", "Filter premium data"]
  },
  {
    id: "irdai-reports",
    title: "IRDAI Reports",
    module: "Reports",
    path: "/retail/reports/irdai-reports",
    menuPath: ["Reports", "IRDAI Reports"],
    privilege: "reports.irdiaReports",
    description: "Generate IRDAI compliance reports and exports.",
    keywords: ["irdai", "irdia", "compliance report", "form 10", "regulatory report"],
    actions: ["Generate IRDAI report", "Download compliance Excel"]
  },
  {
    id: "invoice-reports",
    title: "Invoice Management",
    module: "Finance",
    path: "/finance/manage-invoices",
    menuPath: ["Finance", "Invoice Management"],
    privilege: "finance.invoiceManagement",
    description: "Create, manage, and download invoice reports.",
    keywords: ["invoice", "create invoice", "invoice report", "download invoice"],
    actions: ["Create invoice", "Download invoice PDF"]
  },
  {
    id: "daily-summary",
    title: "Daily Summary",
    module: "Reports",
    path: "/reports/daily-summary",
    menuPath: ["Reports", "Daily Summary"],
    privilege: "reports.dailySummary",
    description: "Review and configure daily CRM summary reporting.",
    keywords: ["daily summary", "summary report", "daily report"],
    actions: ["View daily summary", "Configure report email"]
  },
  {
    id: "create-user",
    title: "Create User",
    module: "System Settings",
    path: "/register",
    menuPath: ["System Settings", "Employees", "Create User"],
    privilege: "systemSettings.employees.userCreation.management.create",
    description: "Create employee user accounts for CRM access.",
    keywords: ["create user", "register user", "add employee", "new user"],
    actions: ["Create employee login", "Assign initial user details"]
  },
  {
    id: "roles",
    title: "Roles",
    module: "System Settings",
    path: "/admin/roles",
    menuPath: ["System Settings", "Employees", "Roles"],
    privilege: "systemSettings.employees.roleManagement.operations.view",
    alternatePrivileges: [
      "systemSettings.employees.roleManagement.operations.create",
      "systemSettings.employees.roleManagement.operations.edit",
      "systemSettings.employees.roleManagement.operations.clone",
      "systemSettings.employees.roleManagement.operations.delete"
    ],
    description: "Create and maintain role-based privilege sets.",
    keywords: ["role", "roles", "rbac", "permission role"],
    actions: ["Create role", "Assign privileges to role"]
  },
  {
    id: "manage-users",
    title: "Manage Users",
    module: "System Settings",
    path: "/users/manage",
    menuPath: ["System Settings", "Employees", "Manage Users"],
    privilege: "systemSettings.employees.manageUsers.operations.view",
    alternatePrivileges: [
      "systemSettings.employees.manageUsers.operations.export",
      "systemSettings.employees.manageUsers.operations.edit",
      "systemSettings.employees.manageUsers.operations.resetPassword",
      "systemSettings.employees.manageUsers.operations.viewHierarchy",
      "systemSettings.employees.manageUsers.operations.delete"
    ],
    description: "Update user profiles, status, roles, and assigned privileges.",
    keywords: ["manage users", "employee", "inactive user", "user privileges"],
    actions: ["Edit user", "Manage user privileges"]
  },
  {
    id: "retail-clients",
    title: "Retail Clients",
    module: "System Settings",
    path: "/retail/client-list",
    menuPath: ["System Settings", "Client Management", "Retail Clients"],
    privilege: "clientManagement.retail.operations.view",
    description: "Manage retail client master records.",
    keywords: ["retail client", "client master", "manage client"],
    actions: ["Add retail client", "Edit client details"]
  },
  {
    id: "corporate-clients",
    title: "Corporate Clients",
    module: "System Settings",
    path: "/corporate/client-list",
    menuPath: ["System Settings", "Client Management", "Corporate Clients"],
    privilege: "clientManagement.corporate.operations.view",
    description: "Manage corporate client master records.",
    keywords: ["corporate client", "company client", "corporate master"],
    actions: ["Add corporate client", "Edit company details"]
  },
  {
    id: "insurer-master",
    title: "Insurer Master",
    module: "System Settings",
    path: "/insurer-master",
    menuPath: ["System Settings", "Product Master", "Insurer Master"],
    privilege: "productMaster.insurer.management.view",
    description: "Maintain insurance company master data.",
    keywords: ["insurer", "insurance company", "insurer master"],
    actions: ["Add insurer", "Edit insurer"]
  },
  {
    id: "insurer-branch-master",
    title: "Insurer Branch Master",
    module: "System Settings",
    path: "/insurer-branch-master",
    menuPath: ["System Settings", "Product Master", "Insurer Branch Master"],
    privilege: "productMaster.insurerBranch.management.view",
    description: "Maintain insurer branch master data.",
    keywords: ["insurer branch", "branch master", "add insurer branch"],
    actions: ["Add insurer branch", "Edit branch details"]
  },
  {
    id: "policy-master",
    title: "Policy Master",
    module: "System Settings",
    path: "/policy-master",
    menuPath: ["System Settings", "Product Master", "Policy Master"],
    privilege: "productMaster.policy.management.view",
    description: "Maintain policy name/product master records.",
    keywords: ["policy master", "policy name", "policy product"],
    actions: ["Add policy master", "Edit policy name"]
  },
  {
    id: "class-of-policy",
    title: "Class of Policy",
    module: "System Settings",
    path: "/class-of-policy-master",
    menuPath: ["System Settings", "Product Master", "Class of Policy"],
    privilege: "productMaster.classOfPolicy.management.view",
    description: "Maintain policy class definitions used during policy entry.",
    keywords: ["class of policy", "policy class", "class master"],
    actions: ["Add class of policy", "Edit policy class"]
  },
  {
    id: "category",
    title: "Category",
    module: "System Settings",
    path: "/category-master",
    menuPath: ["System Settings", "Product Master", "Category"],
    privilege: "productMaster.category.management.view",
    description: "Maintain policy category master records.",
    keywords: ["category", "category master", "policy category"],
    actions: ["Add category", "Edit category"]
  },
  {
    id: "privilege-master",
    title: "Privilege Master",
    module: "System Settings",
    path: "/admin/privileges",
    menuPath: ["System Settings", "Privilege Master"],
    privilege: "privilege.manage",
    description: "Manage privilege definitions and user access rules.",
    keywords: ["privilege", "permissions", "access", "rbac", "permission"],
    actions: ["Create privilege", "Assign privilege"]
  },
  {
    id: "ai-knowledge",
    title: "AI Knowledge",
    module: "System Settings",
    path: "/admin/assistant-knowledge",
    menuPath: ["System Settings", "AI Knowledge"],
    privilege: "privilege.manage",
    description: "Maintain chatbot FAQs, help content, route hints, and permission-aware training entries.",
    keywords: ["ai knowledge", "chatbot", "assistant", "faq", "training content", "help content"],
    actions: ["Add FAQs", "Update help content", "Configure assistant knowledge"]
  },
  {
    id: "geo-location",
    title: "Photo Capture",
    module: "Geo Capture",
    path: "/geo-location",
    menuPath: ["Geo Capture", "Photo Capture"],
    description: "Capture photos with location context.",
    keywords: ["geo", "location", "photo capture", "geo capture"],
    actions: ["Capture geo photo", "Save location evidence"]
  },
  {
    id: "location-list",
    title: "Location Data",
    module: "Geo Capture",
    path: "/location-list",
    menuPath: ["Geo Capture", "Location Data"],
    adminOnly: true,
    description: "Review captured location data.",
    keywords: ["location data", "geo list", "captured location"],
    actions: ["Review location logs"]
  },
  {
    id: "add-pos",
    title: "Add POS",
    module: "POS",
    path: "/add-pos",
    menuPath: ["POS", "Add POS"],
    adminOnly: true,
    description: "Create a POS advisor record.",
    keywords: ["pos", "add pos", "advisor"],
    actions: ["Add POS advisor"]
  },
  {
    id: "pos-details",
    title: "POS Details",
    module: "POS",
    path: "/view-pos",
    menuPath: ["POS", "POS Details"],
    adminOnly: true,
    description: "View and manage POS details.",
    keywords: ["pos details", "view pos"],
    actions: ["Review POS details"]
  },
  {
    id: "pos-advisors",
    title: "POS Advisors",
    module: "POS",
    path: "/pos-list",
    menuPath: ["POS", "POS Advisors"],
    adminOnly: true,
    description: "View POS advisors linked with clients or activity.",
    keywords: ["pos advisors", "client pos"],
    actions: ["Review POS advisors"]
  }
];

export const suggestedAssistantQuestions = [
  "Where can I add endorsement?",
  "How to add policy?",
  "Generate IRDAI Report",
  "Upload Policy Document",
  "Create Invoice",
  "How to process renewals?"
];

export default crmAssistantKnowledge;
